class Carousel {
	constructor(elem) {
		this.carouselWrap = $(elem);
		this.carouselContainer = this.carouselWrap.find('.swiper-container')[0];
		this.prevArrow = this.carouselWrap.find('.swiper-button-prev');
		this.nextArrow = this.carouselWrap.find('.swiper-button-next');
		this.count = this.carouselWrap.attr('data-count') || 6;
		this.space = this.carouselWrap.attr('data-space') || 20;
		this.breakpoints =  {
			1023: {
				slidesPerView: 6,
				slidesPerGroup: 6
			},
			639: {
				slidesPerView: 4,
				slidesPerGroup: 4
			},
			320: {
				slidesPerView: 2,
				slidesPerGroup: 2
			}
		};

		if (this.carouselWrap.attr('data-breakpoints')) {
			this.breakpoints = JSON.parse(this.carouselWrap.attr('data-breakpoints'));
		}
		this.carouselInstance = null;
	}

	init() {
		let _this = this;
		this.carouselInstance = new window.Swiper(this.carouselContainer, {
			spaceBetween: _this.space,
			slidesPerView: _this.count,
			navigation: {
				prevEl: _this.prevArrow,
				nextEl: _this.nextArrow
			},
			breakpoints: _this.breakpoints
		});
	}
}

export {Carousel}

$(document).on('load', () => {
	let carousels = [];

	if ($('[data-carousel]').length > 0) {
		$('[data-carousel]').each(function(i) {
			carousels[i] = new Carousel($(this));
			carousels[i].init();
		});
	}
});
